"use client";


import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { Input } from "@/components/atoms/input";
import Icon from "@/components/atoms/Icons";
import { useDebouncedCallback } from "use-debounce";
import { ListFilter } from "lucide-react";


interface SearchCardGlobalProps {
    onOpenMobileFilters?: () => void;
}

export function SearchCard({ onOpenMobileFilters }: SearchCardGlobalProps) {

    const { replace } = useRouter();
    const searchParams = useSearchParams();
    const pathname = usePathname();

    const handleSearch = useDebouncedCallback((query) => {    
        const params = new URLSearchParams(searchParams || undefined);     
        params.delete("page");
        if (query) {
            params.set("search", query);
        } else {
            params.delete("search");
        }
        replace(`${pathname}?${params.toString()}`);
    }, 300);




    return (
        <div className="flex flex-1 justify-between items-center gap-3 sm:gap-5 relative">
            <div className="relative w-full flex-1">
                <Input
                    type="text"
                    placeholder="Pesquisar "
                    onChange={(e) => {
                        handleSearch(e.target.value);
                    }}
                    className="flex-1 h-[40px] sm:h-[44px] rounded-full pl-12 sm:pl-14 pr-4 text-sm sm:text-base"
                    defaultValue={searchParams ? searchParams.get("search") || "" : ""}
                />
                <Icon name="search" className="absolute top-1/2 left-3 sm:left-4 -translate-y-1/2 text-gray-400 w-4 h-4 sm:w-5 sm:h-5" />
            </div>

            {/* Botão de filtro mobile */}
            <div className="lg:hidden flex-shrink-0">
                <button
                    onClick={onOpenMobileFilters}
                    className="border border-[#BFC4CD] rounded-full p-2 w-10 h-10 sm:w-12 sm:h-12 flex justify-center items-center bg-white hover:bg-gray-50 transition-colors"
                >
                    <ListFilter className="w-5 h-5 sm:w-6 sm:h-6 text-[#616E85]" />
                </button>
            </div>

        </div>
    );
}
